module.exports = __webpack_public_path__ + "static/media/wings persona.35275ca0.png";